import React from "react";
import { Card, CardContent, Typography, Grid, Box, Button } from "@mui/material";

const subscriptionPlans = [
  {
    name: "Monthly",
    billingCycle: "Monthly",
    price: "₹2,500",
    features: [
      "Full access to stock & order management",
      "Production tracking",
      "Alerts and analytics",
    ],
  },
  {
    name: "Yearly",
    billingCycle: "Annually",
    price: "₹24,999",
    features: [
      "Full access",
      "Discounted price (₹5,001 savings compared to monthly plan)",
    ],
  },
  {
    name: "White Labeling",
    billingCycle: "Custom",
    price: "Contact Sales",
    features: [
      "Custom branding",
      "Dedicated database",
      "API access",
      "Priority support",
    ],
  },
];

const PricingPolicy = () => {
  return (
    <Box sx={{ padding: "20px" }}>
      <Typography variant="h4" gutterBottom fontWeight="bold">
        Pricing and Policy
      </Typography>
      <Grid container spacing={3} marginTop={3}>
        {subscriptionPlans.map((plan, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: 300,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                boxShadow: 3,
                background: "linear-gradient(90deg, #3B82F6, #6366F1)",
                color: "white",
              }}
            >
              <CardContent>
                <Typography variant="h6" fontWeight="bold">
                  {plan.name}
                </Typography>
                <Typography variant="subtitle2" color="textSecondary">
                  {plan.billingCycle}
                </Typography>
                <Typography variant="h4" color="white" mt={1} mb={2} fontWeight={600}>
                  {plan.price}
                </Typography>
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  {plan.features.map((feature, idx) => (
                    <li key={idx} style={{ fontSize: "14px" }}>
                      {feature}
                    </li>
                  ))}
                </Box>
              </CardContent>
              <Box textAlign="center" pb={2}>
                <Button
                  variant="contained"
                  sx={{
                    backgroundColor: "white",
                    color: "#3B82F6",
                    borderRadius: "20px",
                    "&:hover": { backgroundColor: "#e0e0e0" },
                  }}
                >
                  <b>Get Started</b>
                </Button>
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default PricingPolicy;
